import React, { memo, forwardRef } from "react";
const SvgEndofproof = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={14} height={14} x={9} y={9} fill="#717171" rx={2} />
    </svg>
  );
});
SvgEndofproof.displayName = "SvgEndofproof";
const MemoForwardRef = memo(SvgEndofproof);
export default MemoForwardRef;
